import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../../../store/ancillary/actions';
import PersonSearch from '../../PersonSearch/PersonSearch';
import { modelAfterPropTypes as propTypes } from './_types';
import { checkUsersForUser } from './_utilities';

import Icon from '../../../MDC/Icon/Icon';
import { Tooltip } from '../../../MDC/Tooltip/Tooltip';

const ModelAfter = ({ withoutFormik = false, ...props }) => {
	const formIndex = useSelector(state =>
		Object.keys(state.apps.allForms).find(
			formIndex => state.apps.allForms[formIndex].id === props.appId
		)
	);
	const requestorID = useSelector(
		state => state.apps.allForms[formIndex].model.UserID
	);
	const modelUsersFiltered = useSelector(
		state => state.ancillary.modelUsersFiltered
	);
	const errorMessage = useSelector(state => state.ancillary.error);
	const isLoading = useSelector(state => state.ancillary.loading);
	const dispatch = useDispatch();

	const isRequestorInUsers = checkUsersForUser(
		modelUsersFiltered,
		requestorID
	);

	const toolTipPosition = document.body.clientWidth > 750 ? 'right' : 'top';
	const labelText = () => {
		return (
			<>
				Model User Search{' '}
				<Tooltip
					activateOn='hover'
					align={toolTipPosition}
					content='Search existing users of application whose access will serve as model for request.'
				>
					<Icon icon='info' />
				</Tooltip>
			</>
		);
	};
	return (
		<PersonSearch
			dataTable={{
				headers: [
					{
						Value: 'Username',
					},
				],
				label: 'User Results (Please select one)',
				onRowClickedHandler: packet => {
					//  clear search results
					dispatch(actions.modelAfterClear());

					//  update value, validate
					let event = {
						target: {
							name: props.name,
							value: packet.payload.Cells['Username'].Value,
						},
					};
					props.changeHandler(event, true);
				},
				onTextFieldChangedHandler: e => {
					dispatch(actions.filterModelAfter(e.target.value));
				},
				rows: isRequestorInUsers
					? modelUsersFiltered.filter(
							model =>
								model.Cells['F_ESO_ID'].Value !== requestorID
					  )
					: modelUsersFiltered,
			}}
			displayHeader={{
				Value: 'Username',
			}}
			errorMessage={errorMessage}
			isLoading={isLoading}
			label={labelText()}
			onButtonClickedHandler={packet => {
				if (packet && packet.payload && packet.payload.Input) {
					packet.payload.Input.Extensions = {
						App_ID: props.appId,
					};
				}
				dispatch(actions.modelAfter(packet));
			}}
			onChipRemovedHandler={() => {
				let event = {
					target: {
						name: props.name,
						value: '',
					},
				};
				props.changeHandler(event, true);
			}}
			requestTarget='MODEL_AFTER'
			value={props.value}
			warningMessage={
				isRequestorInUsers
					? 'Users may not model after themselves.'
					: null
			}
			withoutFormik={withoutFormik}
			onBlur={props.onBlur}
		/>
	);
};

ModelAfter.propTypes = propTypes;

export default ModelAfter;
